import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import ProgrammesComponets from "@/components/Programmes/ProgrammesComponent.vue";
import brand_details from "@/data/brand_details";
import { get_user_profile } from "@/router";
import { is_admin_user } from "@/utils/auth_user";

const details = brand_details();

export default {
  name: "PortfolioSidebar",

  components: {
    SidebarShell,
    ProgrammesComponets
  },

  props: {
    tiles: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return ({
      brand_name: details.name,
      brand_subtitle: details.subtitle,
      active_menu_item: "portfolio-comparisons",
      dropdown_open: false,
      regions_dropdown_open: false,
      selected_region: null,
      active_programme_id: null,
      full_name: "Guest User",
      initials: "GU",
      short_logo: details.logo
    });
  },

  computed: {
    is_admin_user() {
      return is_admin_user(get_user_profile());
    },

    regions_formatted() {
      const raw = this.tiles
        .map((tile) => tile.region || tile.region_name || tile.province || tile.area || null)
        .filter(Boolean);

      return [...new Set(raw)].map((region) => ({
        id: region,
        label: region
      }));
    },

    selected_region_label() {
      return this.selected_region || "Regions";
    },

    menu_items() {
      const items = [
        { key: "portfolio-comparisons", label: "Dashboard", icon: "bi bi-bar-chart-line" },
        { key: "company-profile", label: "Company Profile", icon: "bi bi-building" },
        { key: "verification", label: "Verification", icon: "bi bi-check2-circle" },
        { key: "certificates-reports", label: "Certificates & Reports", icon: "bi bi-award-fill" },
        { key: "programmes_component", type: "component" },
        { key: "integration", label: "Integration", icon: "bi bi-plug-fill" },
        { key: "settings", label: "Settings", icon: "bi bi-gear-fill" },
        { key: "help", label: "Help", icon: "bi bi-question-circle-fill" }
      ];

      if (!this.is_admin_user) {
        return items.filter((item) => item.key !== "settings");
      }

      return items;
    }
  },

  mounted() {
    this.load_user_name();
  },

  methods: {
    toggle_regions_dropdown() {
      this.regions_dropdown_open = !this.regions_dropdown_open;
    },

    select_region(region) {
      this.selected_region = region ? region.id : null;
      this.regions_dropdown_open = false;
      this.$emit("region-selected", this.selected_region);
    },

    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      this.full_name = name;
      this.initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "GU";
    },

    toggle_dropdown() {
      this.dropdown_open = !this.dropdown_open;
    },

    select_menu_item(menuItem) {
      this.active_menu_item = menuItem;
      this.dropdown_open = false;
      this.$emit("global-menu-selected", menuItem);
    },

    open_programme(programme) {
      this.active_programme_id = programme?.id ?? null;
      this.active_menu_item = "programmes";
      this.dropdown_open = false;
      this.$emit("open-programme", programme);
    }
  }
};
